import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const COOKIE_KEY = "cookie-consent";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(COOKIE_KEY)) {
        const timer = setTimeout(() => setVisible(true), 4000);
        return () => clearTimeout(timer);
      }
    } catch {
      // localStorage unavailable
    }
  }, []);

  const handleChoice = (accepted: boolean) => {
    try {
      localStorage.setItem(COOKIE_KEY, accepted ? "accepted" : "declined");
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9998] px-4 pb-2 pt-1 animate-fade-in-up">
      <div className="max-w-3xl mx-auto bg-card/95 backdrop-blur-sm border border-border rounded-lg shadow-md px-3 py-2 flex items-center gap-2">
        <p className="text-[11px] text-muted-foreground leading-snug flex-1">
          We use cookies to improve performance.{" "}
          <Link to="/privacy" className="text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
            Privacy
          </Link>
        </p>
        <div className="flex items-center gap-1.5 shrink-0">
          <Button size="sm" className="h-6 text-[10px] px-2.5" onClick={() => handleChoice(true)}>
            Accept
          </Button>
          <button onClick={() => handleChoice(false)} className="text-muted-foreground hover:text-foreground transition-colors p-0.5" aria-label="Decline cookies">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
